// Podtemat 4 - zadania zamkniete egzaminu osmioklasisty z dzialu I.

import * as MixedNumberExpression from "../temat10_ulamki_zwykle/podtemat7_dzialania_laczne_wymierne_types/E8MixedNumberExpressionClosedTask";
import * as RemainderChoice from "../temat5_teoria_liczb/podtemat1_podzielnosc_liczb_calkowitych_types/E8RemainderChoiceClosedTask";
import * as RootExpressionsTruth from "../temat2_potegi/podtemat3_potegi_wymierne_types/E8RootExpressionsTruthClosedTask";
import * as PowerQuotientBaseTwo from "../temat2_potegi/podtemat1_potegi_naturalne_types/E8PowerQuotientBaseTwoClosedTask";
import * as NumberLinePF from "../temat9_liczby_calkowite/E8NumberLinePFClosedTask";
import * as LockerCodeNwdNww from "../temat5_teoria_liczb/podtemat3_nwd_nww_types/E8LockerCodeNwdNwwClosedTask";
import * as RootZeroExpression from "../temat2_potegi/podtemat3_potegi_wymierne_types/E8RootZeroExpressionClosedTask";
import * as PowerProductCombine from "../temat2_potegi/podtemat1_potegi_naturalne_types/E8PowerProductCombineClosedTask";
import * as BallsParity from "../temat5_teoria_liczb/podtemat1_podzielnosc_liczb_calkowitych_types/E8BallsParityClosedTask";

export const registry = {
  E8MixedNumberExpressionClosedTask: MixedNumberExpression,
  E8RemainderChoiceClosedTask: RemainderChoice,
  E8RootExpressionsTruthClosedTask: RootExpressionsTruth,
  E8PowerQuotientBaseTwoClosedTask: PowerQuotientBaseTwo,
  E8NumberLinePFClosedTask: NumberLinePF,
  E8LockerCodeNwdNwwClosedTask: LockerCodeNwdNww,
  E8RootZeroExpressionClosedTask: RootZeroExpression,
  E8PowerProductCombineClosedTask: PowerProductCombine,
  E8BallsParityClosedTask: BallsParity,
};

export function generateTasks(options = {}) {
  if (options.variant === "original") {
    return [
      MixedNumberExpression.generateTask(options),
      RemainderChoice.generateTask(options),
      RootExpressionsTruth.generateTask(options),
      PowerQuotientBaseTwo.generateTask(options),
      NumberLinePF.generateTask(options),
      LockerCodeNwdNww.generateTask(options),
      RootZeroExpression.generateTask(options),
      PowerProductCombine.generateTask(options),
      BallsParity.generateTask(options),
    ];
  }

  return [
    MixedNumberExpression.generateTask(options),
    RemainderChoice.generateTask(options),
    RootExpressionsTruth.generateTask(options),
    PowerQuotientBaseTwo.generateTask(options),
    NumberLinePF.generateTask(options),
    LockerCodeNwdNww.generateTask(options),
    RootZeroExpression.generateTask(options),
    PowerProductCombine.generateTask(options),
    BallsParity.generateTask(options),
  ];
}

function moduleFor(task) {
  const mod = registry[task.type];
  if (!mod) throw new Error(`Unknown E8 task type: ${task.type}`);
  return mod;
}

export function renderTask(task) {
  return moduleFor(task).renderTask(task);
}

export function renderInput(task, userAnswer, onChange, disabled) {
  return moduleFor(task).renderInput(task, userAnswer, onChange, disabled);
}

export function checkAnswer(task, userAnswer) {
  return moduleFor(task).checkAnswer(task, userAnswer);
}

export function renderAnswer(task) {
  return moduleFor(task).renderAnswer(task);
}

export function renderExplanation(task) {
  return moduleFor(task).renderExplanation(task);
}

export function renderUserAnswer(userAnswer, task) {
  return moduleFor(task).renderUserAnswer(userAnswer, task);
}
